/**
 * F-brand-cleanup — Página "À propos" com info de versão.
 *
 * A versão técnica do produto (antes "v3" no brand) saiu da identidade
 * visível e mora aqui. Acessível via /settings/about. Será integrada à
 * Sidebar quando o AppShell do F13.5 commit 2 estiver entregue.
 */

import { APP_VERSION } from "../../config/version.js";
import { ErpShell } from "../../components/layout/ErpShell.js";
import { useT } from "../../i18n/index.js";

export default function AboutPage() {
  const t = useT();
  const buildHash = import.meta.env.VITE_BUILD_HASH ?? "dev";
  const year = new Date().getFullYear();
  return (
    <ErpShell>
      <main className="max-w-2xl mx-auto p-6">
        <h2 className="font-display font-bold text-3xl mb-6">{t("about.title")}</h2>
        <div className="bg-neutral-900 border border-neutral-800 rounded-md p-6 space-y-5">
          <div>
            <span className="text-xs uppercase text-text-muted tracking-wider">
              {t("about.productLabel")}
            </span>
            <p className="font-display font-bold text-xl mt-1">
              Storm <span className="text-lime">Gestion</span>
            </p>
          </div>
          <div>
            <span className="text-xs uppercase text-text-muted tracking-wider">
              {t("about.versionLabel")}
            </span>
            <p className="font-mono text-sm text-text-secondary mt-1">{APP_VERSION}</p>
          </div>
          <div>
            <span className="text-xs uppercase text-text-muted tracking-wider">
              {t("about.buildLabel")}
            </span>
            <p className="font-mono text-xs text-text-muted mt-1">{buildHash}</p>
          </div>
          <div className="border-t border-white/5 pt-4 text-xs text-text-muted">
            <p>{t("about.tagline")}</p>
            <p className="mt-1">© 2024–{year} Euro Storm Débosselage SAS</p>
          </div>
        </div>
      </main>
    </ErpShell>
  );
}
